var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Статусы заявок на подбор",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "RecruitTaskStatusAdd",
      "route-edit": "RecruitTaskStatusEdit",
      "route-view": "RecruitTaskStatusView",
      "route-path": "/recruit_task_statuses",
      "can-edit": _vm.canEditRecruitTaskStatus()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e75bf8dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e75bf8dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/RecruitTaskStatuses/RecruitTaskStatuses.vue
// module id = null
// module chunks = 